import { PLUGIN_SUITE } from "./content";

export const GAMES = {
  rust: {
    id: "rust",
    name: "Rust",
    catalogueLabel: "RUST PLUGINS",
    term: "Plugin",
  },
  wow: {
    id: "wow",
    name: "World of Warcraft",
    catalogueLabel: "WOW ADDONS",
    term: "Addon",
  },
};

export const RELEASES = [
  {
    slug: "arsenal-hub",
    path: "/downloads/wow/arsenal-hub",
    cardAction: "EXPLORE ARSENAL HUB",
    logo: "/arsenalhub/arsenal-hub-logo.png",
    game: "wow",
    projectType: "addon",
    name: "Arsenal Hub",
    displayName: "ARSENAL HUB",
    client: "WoW Forever",
    category: "Guild Tools",
    version: "3.14.5",
    status: "GUILD RELEASE",
    distribution: "PRIVATE GUILD BUILD",
    downloadEnabled: false,
    releaseDate: "2026-10-11",
    fileType: "EXE",
    fileSize: "≈ 4.78 MiB",
    author: "Arsenal Forge",
    tags: ["GUILD", "EVENTS", "RAIDS", "GEAR", "AUCTIONS"],
    compatibility: "WoW Forever (Interface 16001) · Windows x64",
    summary:
      "WoW Forever guild tools, live raid and event sharing, captured gear, quest guidance and auction research in one in-game interface.",
  },
];

export const RUST_PROJECTS = PLUGIN_SUITE.map((p) => ({
  slug: p.name.toLowerCase().replace(/\s+/g, "-"),
  game: "rust",
  projectType: "plugin",
  name: p.name,
  domain: p.domain,
  summary: p.body,
  availability: "ARSENAL NETWORK EXCLUSIVE",
  downloadEnabled: false,
}));
